import { FETCH_NOTES } from './constants'

export const notesFetched = (notes_list) => {
  return {
    type: FETCH_NOTES,
    notes_list
  }
}



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/Claim/Notes/actions.js